;(function () {
	const initSection = (target) => {
		const sections = target 
            ? target.querySelectorAll('.image-banner-container') 
            : document.querySelectorAll('.image-banner-container');

		sections.forEach(section => {
			const sectionAnimated = section.querySelector('.image-banner__container')
			const heading = section.querySelector('.image-banner__heading')
			const { animation, imageRatio } = section.dataset
			const isAnimation = animation == 'true' && imageRatio == 'large'

            if (section._scrollHandler) {
                window.removeEventListener('scroll', section._scrollHandler);
                section._scrollHandler = null;
            }

            if (!isAnimation) return;

			function changeSectionSizes() {
				const sectionTop = section.getBoundingClientRect().top
				const windowHeight = window.innerHeight

				if (sectionTop <= 0 && window.innerWidth >= 750) {
					const scrollProgress = Math.abs(sectionTop) / windowHeight
					const clampedProgress = Math.min(Math.max(scrollProgress, 0), 1)

					let targetWidth = window.innerWidth - 80
					if (window.innerWidth >= 1360) {
						targetWidth = 1200
					}
					const minWidthPercent = (targetWidth / window.innerWidth) * 100
					const newSize = 100 - (100 - minWidthPercent) * clampedProgress

					if (heading) {
						heading.style.opacity = `${clampedProgress}`
					}

					if (newSize < 99) {
						sectionAnimated.style.borderRadius = '20px'
						sectionAnimated.style.overflow = 'hidden'
					} else {
						sectionAnimated.style.borderRadius = '0'
					}
					sectionAnimated.style.width = `${newSize}%`
					sectionAnimated.style.height = `${newSize}%`
				} else {
					sectionAnimated.style.borderRadius = '0'
					sectionAnimated.style.width = '100%'
					sectionAnimated.style.height = '100%'
				}
			}

            section._scrollHandler = changeSectionSizes;

			if (window.innerWidth >= 750) {
				window.addEventListener('scroll', changeSectionSizes)
                changeSectionSizes()
			}
		});
	}

	initSection()

	document.addEventListener('shopify:section:load', function (event) {
		initSection(event.target)
	})
	window.addEventListener('resize', () => initSection())
})()
